import blinkhusEn from '../resources/en/brands/blinkhus.json';
import defaultEn from '../resources/en/brands/default.json';
import fargerikeEn from '../resources/en/brands/fargerike.json';
import mestergruppenEn from '../resources/en/brands/mestergruppen.json';
import mesterhusEn from '../resources/en/brands/mesterhus.json';
import nordbohusEn from '../resources/en/brands/nordbohus.json';
import rotEn from '../resources/en/brands/rot.json';
import saltdalshyttaEn from '../resources/en/brands/saltdalshytta.json';
import systemhusEn from '../resources/en/brands/systemhus.json';
import xlbyggEn from '../resources/en/brands/xlbygg.json';
import mgleverandorerEn from '../resources/en/brands/mgleverandorer.json';
import pretreEn from '../resources/en/brands/pretre.json';

import blinkhusNo from '../resources/no/brands/blinkhus.json';
import defaultNo from '../resources/no/brands/default.json';
import fargerikeNo from '../resources/no/brands/fargerike.json';
import mestergruppenNo from '../resources/no/brands/mestergruppen.json';
import mesterhusNo from '../resources/no/brands/mesterhus.json';
import nordbohusNo from '../resources/no/brands/nordbohus.json';
import rotNo from '../resources/no/brands/rot.json';
import saltdalshyttaNo from '../resources/no/brands/saltdalshytta.json';
import systemhusNo from '../resources/no/brands/systemhus.json';
import xlbyggNo from '../resources/no/brands/xlbygg.json';
import mgleverandorerNo from '../resources/no/brands/mgleverandorer.json';
import pretreNo from '../resources/no/brands/pretre.json';

import blinkhusSv from '../resources/sv/brands/blinkhus.json';
import defaultSv from '../resources/sv/brands/default.json';
import fargerikeSv from '../resources/sv/brands/fargerike.json';
import mestergruppenSv from '../resources/sv/brands/mestergruppen.json';
import mesterhusSv from '../resources/sv/brands/mesterhus.json';
import nordbohusSv from '../resources/sv/brands/nordbohus.json';
import rotSv from '../resources/sv/brands/rot.json';
import saltdalshyttaSv from '../resources/sv/brands/saltdalshytta.json';
import systemhusSv from '../resources/sv/brands/systemhus.json';
import xlbyggSv from '../resources/sv/brands/xlbygg.json';
import mgleverandorerSv from '../resources/sv/brands/mgleverandorer.json';
import pretreSv from '../resources/sv/brands/pretre.json';

import { BrandLanguageResources } from '../types/BrandResources';

export const brandI18nResources: BrandLanguageResources = {
  no: {
    brand: defaultNo,
    blinkhus: blinkhusNo,
    fargerike: fargerikeNo,
    mestergruppen: mestergruppenNo,
    mesterhus: mesterhusNo,
    nordbohus: nordbohusNo,
    rot: rotNo,
    saltdalshytta: saltdalshyttaNo,
    systemhus: systemhusNo,
    xlbygg: xlbyggNo,
    mgsupp: mgleverandorerNo,
    pretre: pretreNo,
  },
  sv: {
    brand: defaultSv,
    blinkhus: blinkhusSv,
    fargerike: fargerikeSv,
    mestergruppen: mestergruppenSv,
    mesterhus: mesterhusSv,
    nordbohus: nordbohusSv,
    rot: rotSv,
    saltdalshytta: saltdalshyttaSv,
    systemhus: systemhusSv,
    xlbygg: xlbyggSv,
    mgsupp: mgleverandorerSv,
    pretre: pretreSv,
  },
  en: {
    brand: defaultEn,
    blinkhus: blinkhusEn,
    fargerike: fargerikeEn,
    mestergruppen: mestergruppenEn,
    mesterhus: mesterhusEn,
    nordbohus: nordbohusEn,
    rot: rotEn,
    saltdalshytta: saltdalshyttaEn,
    systemhus: systemhusEn,
    xlbygg: xlbyggEn,
    mgsupp: mgleverandorerEn,
    pretre: pretreEn,
  },
};
